import client from './client';

const PIPELINE_BASE_PATH = '/api/v1/pipeline';

export async function runPipeline(payload = {}) {
  const { dataset_id, max_parallel_batches, config_file_id, format_file } = payload;
  const res = await client.post(`${PIPELINE_BASE_PATH}/run`, null, {
    params: {
      dataset_id,
      max_parallel_batches,
      config_file_id,
      format_file,
    },
  });
  return res.data;
}

export async function getPipelineReports({ status, limit = 50, offset = 0 } = {}) {
  const res = await client.get(`${PIPELINE_BASE_PATH}/reports`, {
    params: {
      status,
      limit,
      offset,
    },
  });
  return res.data;
}

export async function getReportDetails(taskId) {
  const res = await client.get(`${PIPELINE_BASE_PATH}/reports/${taskId}`);
  return res.data;
}

export async function downloadPipelineReport(taskId, artifactPath) {
  const res = await client.get(`${PIPELINE_BASE_PATH}/reports/${taskId}/download`, {
    params: {
      artifact_path: artifactPath,
    },
    responseType: 'blob',
  });
  return res.data;
}

export async function listPipelineTasks({ limit = 50, offset = 0, status } = {}) {
  const res = await client.get(`${PIPELINE_BASE_PATH}/tasks`, {
    params: {
      limit,
      offset,
      status,
    },
  });
  return res.data;
}

export async function getTaskStatus(taskId) {
  const res = await client.get(`${PIPELINE_BASE_PATH}/tasks/${taskId}`);
  return res.data;
}

export async function getPipelineConcurrencyStats() {
  const res = await client.get(`${PIPELINE_BASE_PATH}/concurrency`);
  return res.data;
}

export async function resetPipelineConcurrencyState() {
  const res = await client.post(`${PIPELINE_BASE_PATH}/concurrency/reset`);
  return res.data;
}

export async function deletePipelineTask(taskId) {
  await client.delete(`${PIPELINE_BASE_PATH}/tasks/${taskId}`);
}
